import { Input, OnInit, OnDestroy, Injectable } from '@angular/core';
import { EventManager } from '../../../../src/app/core';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { SubscriptionService } from '../services/subscription.service';

@Injectable({ providedIn: 'any' })
export abstract class EditComponent implements OnInit, OnDestroy {
  @Input() queryParams: any = {};
  editForm: any;
  id: any;
  detailObject: any = {};
  classModel: any;
  errors: any = {};
  errorMessage: string = '';
  isSaved: boolean = false;
  isCalling: boolean = false;
  isUpload: boolean = false;
  subscriptions?: Subscription[] = [];
  susCommon?: Subscription[] = [];
  callApi$ = new Subject();
  subscribeState: any;
  constructor(
    public eventManager: EventManager,
    public route: ActivatedRoute
  ) {
  }
  ngOnInit() {
    const params = this.route.snapshot.params;
    this.id = params.id;
    if (this.id) {
      this.getDetail();
    }
    this.subscribeState = SubscriptionService.register(2, this.parseData.bind(this));
    this.susCommon = [
      this.eventManager.subscribe('uploading-file', (res) => {
        this.isUpload = true;
      }),
      this.eventManager.subscribe('uploading-file-done', (res) => {
        this.isUpload = false;
      }),
      this.callApi$.pipe(
        debounceTime(500),
        ).subscribe((event)=> { return this.callAPI(event);})
    ];
  }
  ngOnDestroy() {
    if (this.subscriptions.length > 0) {
      this.eventManager.destroys(this.subscriptions);
    }
    if (this.susCommon.length > 0) {
      this.eventManager.destroys(this.susCommon);
    }
  }
  parseData() {}
  onResponse(next, err) {
    if (next) {
      this.onSuccess(next);
    }
    if (err) {
      this.onError(err);
    }
  }
  getDetail() {}
  checkNull(response) {
    const res = (response.body || {}).data || response.data || response;
    if (!res) {
      return true;
    }
    return false;
  }
  onSuccess(res) {
    if (this.checkNull(res)) {
      return;
    }
    const object = res.body.data || {};
    this.detailObject = this.classModel ? new this.classModel(object) : object;
    this.updateForm();
  }
  onError(error) {}
  updateForm() {}
  getValueForm(key: string) {
    return this.editForm.get(key) || {};
  }
  patchValue(field, value) {
    this.editForm.patchValue({
      [field]: value
    })
  }
  patchForm(field, value) {
    this.editForm.patchValue({
      [field]: value
    })
  }
  disabledButton() {
    const keys = Object.keys(this.errors);
    const key = keys.find(key => this.errors[key]);
    return key ? true : false;
  }
  callAPI(event?) {
    this.save();
  }
  save() {
    this.isSaved =  true;
    if (this.disabledButton()) {
      return;
    }
  }
}
